import { createAction, props } from '@ngrx/store';
import {
  Contrato,
  CreateContratoRequest,
  UpdateContratoRequest
} from '../models/contrato.interface';

// Load Contratos
export const loadContratos = createAction('[Contrato] Load Contratos');

export const loadContratosSuccess = createAction(
  '[Contrato] Load Contratos Success',
  props<{ contratos: Contrato[] }>()
);

export const loadContratosFailure = createAction(
  '[Contrato] Load Contratos Failure',
  props<{ error: string }>()
);

// Create Contrato
export const createContrato = createAction(
  '[Contrato] Create Contrato',
  props<{ contrato: CreateContratoRequest }>()
);

export const createContratoSuccess = createAction(
  '[Contrato] Create Contrato Success',
  props<{ contrato: Contrato }>()
);

export const createContratoFailure = createAction(
  '[Contrato] Create Contrato Failure',
  props<{ error: string }>()
);

// Update Contrato
export const updateContrato = createAction(
  '[Contrato] Update Contrato',
  props<{ id: number; contrato: UpdateContratoRequest }>()
);

export const updateContratoSuccess = createAction(
  '[Contrato] Update Contrato Success',
  props<{ contrato: Contrato }>()
);

export const updateContratoFailure = createAction(
  '[Contrato] Update Contrato Failure',
  props<{ error: string }>()
);

// Delete Contrato
export const deleteContrato = createAction('[Contrato] Delete Contrato', props<{ id: number }>());

export const deleteContratoSuccess = createAction(
  '[Contrato] Delete Contrato Success',
  props<{ id: number }>()
);

export const deleteContratoFailure = createAction(
  '[Contrato] Delete Contrato Failure',
  props<{ error: string }>()
);

// Search Contratos
export const searchContratos = createAction(
  '[Contrato] Search Contratos',
  props<{ query: string }>()
);

export const searchContratosSuccess = createAction(
  '[Contrato] Search Contratos Success',
  props<{ results: Contrato[] }>()
);

export const clearContratoSearch = createAction('[Contrato] Clear Search');

// Select Contrato
export const selectContrato = createAction(
  '[Contrato] Select Contrato',
  props<{ contrato: Contrato | null }>()
);

// Clear Error
export const clearContratoError = createAction('[Contrato] Clear Error');
